import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'store/rootReducers';
import { setGoogleMapsKey } from 'reducers/gmaps';

/**
 * Syncs the build-time Google Maps key (REACT_APP_GOOGLE_MAPS_API_KEY) into
 * Redux once, on first render where it's still unset. No-ops if a key is
 * already in state, or if the env var isn't configured.
 */
export function useGoogleMapsKey() {
	const dispatch = useDispatch();
	const mapsApiKey = useSelector((state: RootState) => state.gmaps.apiKey);

	useEffect(() => {
		if (mapsApiKey) {
			return;
		}
		const key = import.meta.env.REACT_APP_GOOGLE_MAPS_API_KEY;
		if (key) {
			dispatch(setGoogleMapsKey(key));
		}
	}, [mapsApiKey, dispatch]);
}
